export default {"src":"/_next/static/media/WINDOWS.e79b0042.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};